class AddToFav {


    constructor() {
        this.addToFavLink = $('.btn--add-to-fav');
        this.pageID = this.addToFavLink.data('pageid');
        this.cookieName = 'FavPage';
        this.favPageLink = $('.favs');

        let that = this;
        $(this.addToFavLink).on('click tap', function (e) {

            if ($(this).hasClass('is-fav')) {
                let newCookieVal = that.getCookie().replace('-' + that.pageID + '-', "-");
                if (newCookieVal.length == 1) {
                    that.favPageLink.removeClass('active')
                    // Cookie löschen
                    that.setCookie('', true);
                } else {
                    that.setCookie(that.getCookie() + that.pageID + '-');
                }
                $(this).removeClass('is-fav');
                Swal.fire({
                    title: 'Die Seite wurde von Ihrer Merkliste entfernt.',
                    html: '<div class="htmleditor"><a href="/de/favoriten" class="t-def--din">Ihre Merkliste aufrufen</a><br>' +
                        '</div>',
                    showCloseButton: true,
                    showConfirmButton: false
                })
            } else {

                if (that.getCookie() === null) {
                    that.setCookie('-' + that.pageID + '-');
                } else {
                    that.setCookie(that.getCookie() + that.pageID + '-');
                }
                that.favPageLink.addClass('active');
                $(this).addClass('is-fav');
                Swal.fire({
                    title: 'Die Seite wurde zu Ihrer Merkliste hinzugefügt.',
                    html: '<div class="htmleditor"><a href="/de/favoriten" class="t-def--din">Ihre Merkliste aufrufen</a><br>' +
                        '</div>',
                    showCloseButton: true,
                    showConfirmButton: false
                })

            }
            e.preventDefault();
        });
    }

    setCookie(cValue, removeCookie = false) {
        let that = this;
        let date = new Date();
        if (removeCookie != false) {
            date.setTime(1);
        } else {
            date.setTime(date.getTime() + (100 * 24 * 60 * 60 * 1000));
        }

        const expires = "expires=" + date.toUTCString();
        document.cookie = that.cookieName + "=" + cValue + "; " + expires + "; path=/";
    }

    getCookie() {
        let that = this;
        let c_value = document.cookie,
            c_start = c_value.indexOf(" " + that.cookieName + "=");
        if (c_start == -1) c_start = c_value.indexOf(that.cookieName + "=");
        if (c_start == -1) {
            c_value = null;
        } else {
            c_start = c_value.indexOf("=", c_start) + 1;
            let c_end = c_value.indexOf(";", c_start);
            if (c_end == -1) {
                c_end = c_value.length;
            }
            c_value = unescape(c_value.substring(c_start, c_end));
        }
        return c_value;
    }
}